/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployerMatchClosureReasonFromJSON, EmployerMatchClosureReasonToJSON, } from './EmployerMatchClosureReason.js';
/**
 * Check if a given object implements the CloseMatchCommandDto interface.
 */
export function instanceOfCloseMatchCommandDto(value) {
    if (!('matchId' in value) || value['matchId'] === undefined)
        return false;
    if (!('closureReason' in value) || value['closureReason'] === undefined)
        return false;
    if (!('excludeApplicantFor12Months' in value) || value['excludeApplicantFor12Months'] === undefined)
        return false;
    return true;
}
export function CloseMatchCommandDtoFromJSON(json) {
    return CloseMatchCommandDtoFromJSONTyped(json, false);
}
export function CloseMatchCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchId': json['matchId'],
        'closureReason': EmployerMatchClosureReasonFromJSON(json['closureReason']),
        'closureMessage': json['closureMessage'] == null ? undefined : json['closureMessage'],
        'excludeApplicantFor12Months': json['excludeApplicantFor12Months'],
    };
}
export function CloseMatchCommandDtoToJSON(json) {
    return CloseMatchCommandDtoToJSONTyped(json, false);
}
export function CloseMatchCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matchId': value['matchId'],
        'closureReason': EmployerMatchClosureReasonToJSON(value['closureReason']),
        'closureMessage': value['closureMessage'],
        'excludeApplicantFor12Months': value['excludeApplicantFor12Months'],
    };
}
